export const formatFullName = (
  firstName?: string,
  lastName?: string,
  defaultResponse = "-"
) => {
  if (!firstName && !lastName) return defaultResponse;
  return `${firstName ?? ""} ${lastName ?? ""}`.trim();
};
